import { render, staticRenderFns } from "./e4s-layout.vue?vue&type=template&id=15363f4a&"
import script from "./e4s-layout.vue?vue&type=script&lang=ts&"
export * from "./e4s-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports